export * from './table.mapper'
